module.exports = __webpack_public_path__ + "static/media/iconsTemperature.229c3941.svg";